<template>
  <el-row type="flex" justify="space-between" :gutter="10" class="report__header">
    <el-col :span="2" />
    <el-col class="report__header-date" :span="2"> Отчет </el-col>
    <el-col class="report__header-info" :span="3"> Кем создан </el-col>
    <el-col class="report__header-info" :span="9"> Общая информация </el-col>
    <el-col class="report__header-weights" :span="3"> Веса </el-col>
    <el-col class="report__header-amount" :span="3"> Суммы </el-col>
    <el-col class="report__header-comments" :span="2">Комментарии</el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Header',
}
</script>

<style lang="sass" scoped>
.report__header
    font-size: 14px
    margin-bottom: 25px
    margin-top: 30px
    text-align: center
</style>
